export const PLAYGROUND_TEXTS: Record<string, Record<string, string>> = {
  es: {
    DOWNLOAD: "Descargar",
    RUN: "Ejecutar",
    RESET: "Reiniciar",
    RESULT: "Resultado",
    LOADING: "Preparando ejemplo…",
  },
  en: {
    DOWNLOAD: "Download",
    RUN: "Run",
    RESET: "Reset",
    RESULT: "Result",
    LOADING: "Preparing example…",
  },
};
